export default {
  all: [],
};
